import { render } from "./DashboardSideBarMenu.vue?vue&type=template&id=c54069e4"
import script from "./DashboardSideBarMenu.vue?vue&type=script&lang=js"
export * from "./DashboardSideBarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__